/**
 * Test IDs for QA automation.
 */
export const testIds = {
  selectCustomFieldInputPicker: "select-custom-field-input-picker",
  selectCustomFieldInputSearch: "select-custom-field-input-search",
} as const;
